<template>
    <div>
        <headerNotice routerName="修改发货仓库及物流"></headerNotice>
        <!-- 发货表格 -->
        <div class="dataTable" v-loading="loading">
            <el-table class="tableBox" :data="orderList" style="width: 100%">
                <el-table-column align="center" prop="orderCode" label="订单编号" width="200"></el-table-column>
                <el-table-column align="center" prop="recipient" label="收货人" width="100"></el-table-column>
                <el-table-column align="center" prop="phone" label="手机号码" width="150"></el-table-column>
                <el-table-column align="center" prop="address" label="收货地址"></el-table-column>
                <el-table-column align="center" label="发货仓库">
                    <template slot-scope="scope">
                        <el-select
                            v-model="scope.row.houseID"
                            @change="autoChooseLogistics"
                            @focus="getHouseIndex(scope.$index)"
                            placeholder="请选择发货仓库"
                        >
                            <el-option label="请选择发货仓库" disabled :value="0"></el-option>
                            <el-option
                                v-for="item in houseList"
                                :key="item.houseID"
                                :label="item.houseName"
                                :value="item.houseID"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column align="center" label="物流公司">
                    <template slot-scope="scope">
                        <el-select v-model="scope.row.logisticsID" placeholder="请选择物流公司">
                            <el-option
                                v-if="!scope.row.logisticsArray.length"
                                label="请先选择发货仓库"
                                disabled
                                :value="0"
                            ></el-option>
                            <el-option
                                v-if="scope.row.logisticsArray.length"
                                label="请先选择物流公司"
                                disabled
                                :value="0"
                            ></el-option>
                            <el-option
                                v-for="item in scope.row.logisticsArray"
                                :key="item.logisticsID"
                                :label="item.logisticsName"
                                :value="item.logisticsID"
                            ></el-option>
                        </el-select>
                    </template>
                </el-table-column>
                <el-table-column align="center" prop="expressNo" label="物流单号">
                    <template slot-scope="scope">
                        <el-input v-model="scope.row.expressNo" clearable></el-input>
                    </template>
                </el-table-column>
            </el-table>
            <!-- 多选操作 -->
            <div style="margin-top: 20px;text-align:center;">
                <el-button type="info" @click="cancel">返回</el-button>
                <el-button type="primary" :loading="btnLoading" @click="deliverConfirm">确定</el-button>
            </div>
        </div>
    </div>
</template>

<script>
import headerNotice from './../../components/common/headerNotice.vue'
export default {
    data() {
        return {
            orderIDArr: [],
            orderList: [],
            houseList: [],
            loading: false,
            btnLoading: false,
            houseIndex: 0,
        }
    },
    components: {
        headerNotice
    },
    mounted() {
        if (sessionStorage.getItem('orderIDArr')) {
            this.orderIDArr = sessionStorage.getItem('orderIDArr');
            this.orderIDArr = this.orderIDArr.split(',')
            this.getDatas();
            this.getSelectData();
        }
    },
    methods: {
        //获取列表数据
        getDatas() {
            let self = this;
            self.loading = true;
            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/DeliverList",
                data: {
                    orderIDs: this.orderIDArr
                },
                success(res) {
                    self.orderList = res;
                    self.loading = false;
                    if (res.length) {
                        self.orderList.forEach((item, index) => {
                            if (item.houseID == 0) {
                                return
                            }
                            self.fillLogistics(item.houseID, index,item.logisticsID,item.logisticsName)
                        })
                    }
                },
                fail(res) {
                    self.loading = false;
                }
            })
        },
        //获取下拉数据
        getSelectData() {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Warehouse/GetAllWareHouse",
                success(res) {
                    self.houseList = res;
                },
                fail(res) {
                }
            })
        },
        //取消
        cancel() {
            this.$router.back();
        },
        //获取要选择仓库的订单索引
        getHouseIndex(index) {
            this.houseIndex = index;
        },
        //选择仓库后 自动选择物流公司
        autoChooseLogistics(val, index) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Warehouse/GetLogisticsByHouseId",
                params: {
                    houseid: val
                },
                success(res) {
                    self.orderList[self.houseIndex].logisticsArray = res;
                    if (res.length) {
                        self.orderList[self.houseIndex].logisticsID = res[0].logisticsID
                        self.orderList[self.houseIndex].logisticsName = res[0].logisticsName
                    }else {
                        self.orderList[self.houseIndex].logisticsArray = [];
                        self.orderList[self.houseIndex].logisticsID  = 0;
                    }
                },
                fail(res) {
                }
            })

        },
        //页面加载后填充物流公司
        fillLogistics(val, index,logisticsID,logisticsName) {
            let self = this;
            $http.GET({
                url: this.$store.state.apiUrl + "/api/services/app/Warehouse/GetLogisticsByHouseId",
                params: {
                    houseid: val
                },
                success(res) {
                    if (res.length) {
                        self.orderList[index].logisticsArray = res;
                        if(logisticsID || logisticsName){
                            self.orderList[index].logisticsID = logisticsID;
                            self.orderList[index].logisticsName = logisticsName;
                        }else {
                            self.orderList[index].logisticsID = res[0].logisticsID
                            self.orderList[index].logisticsName = res[0].logisticsName
                        }
                       
                    }else {
                        self.orderList[index].logisticsArray = [];
                        self.orderList[index].logisticsID  = 0;
                    }
                },
                fail(res) {
                }
            })

        },
        //发货确认
        deliverConfirm() {
            let self = this;
            let submitOrder = [];
            self.btnLoading = true;
            self.orderList.forEach((ele, index) => {
                submitOrder.push({
                    "orderID": ele.orderID,
                    "houseID": ele.houseID,
                    "logisticsID": ele.logisticsID,
                    "expressNo": ele.expressNo,
                })
            })

            $http.POST({
                url: this.$store.state.apiUrl + "/api/services/app/AdminOrder/AlterExpressVol",
                data: {
                    deliver: submitOrder
                },
                success(res) {
                    self.$message({
                        message: '修改成功！',
                        type: 'success'
                    });
                    self.getDatas();
                    self.btnLoading = false;
                },
                fail(res) {
                    self.btnLoading = false;
                }
            })

        },
    }
}
</script>

<style lang='scss' scoped>
.dataTable {
    margin: 20px 40px;
    .tableBox {
        border: 1px solid #c5c5c5;
    }
}
</style>